// Cesty závislé na instanci shopu (dev 797093.myshoptet.com / ostrá
// www.jipos.cz) — odvozují se za běhu z location, takže tentýž build funguje
// na obou instancích beze změny (runbook go-live, krok „přepis instance
// cest"). Offline fixtures (file://) spadnou na dev instanci, aby devchecky
// viděly reálné assety.
// `typeof` guard: devchecky importují moduly i v Node, kde `location` není
import SHOP from '../../config/shop.js';

const HOST =
  typeof location === 'undefined' || location.protocol === 'file:'
    ? SHOP.instances.assetsHost
    : location.hostname;

// hero/bento/marketingová média nahraná přes deploy/upload-media.ps1
export const MEDIA = `https://${HOST}/user/documents/upload/assets/media/`;

// obrázky článků blogu (CDN cesta nese hostname instance v `usr/`)
export const ART_IMG = `https://cdn.myshoptet.com/usr/${HOST}/user/articles/images/`;

// loga dopravců a ikony nahrané v administraci (Nastavení → Soubory,
// /upload/static/ico/) — na dev i na ostré tatáž jména souborů
export const STATIC_ICO = `https://cdn.myshoptet.com/usr/${HOST}/user/documents/upload/static/ico/`;

// Náš build (main.css, build.min.js, logos.svg) na CDN. Na rozdíl od cest výš se
// NEodvozuje z location: Bender proxuje shop na localhost:3010 a file:// fixtures
// hostname shopu nemají vůbec, takže `HOST` by tu lhal. Volající proto sahá
// primárně na `<script src>` nasazeného bundlu (nese instanci i `?v=`) a tohle
// je fallback na dev instanci — viz `injectSprite.js logosUrl()`.
// Host bere z manifestu shopu (`instances.assetsHost`).
export const DEV_ASSETS = `https://cdn.myshoptet.com/usr/${SHOP.instances.assetsHost}/user/documents/upload/assets/`;
